import { ESchoolGrade, Profile } from '@teko/user';
import { IComboProduct } from './combo';

export interface IGetProductReviewsParams {
  page: number;
  pageSize: number;
  hasImage?: boolean;
  hasVideo?: boolean;
  rating?: number;
  platformId?: number;
}

export interface IProductReview {
  id: number;
  userAvatar?: string;
  userName: string;
  userContact?: string;
  createdAt: number;
  review: {
    rating: number;
    comment: string;
    images?: string[];
    videos?: string[];
  };
}

export interface IRatingCount {
  star: number;
  count: number;
}

export interface IGetProductReviewResponse {
  averageRating?: number;
  totalReviews?: number;
  ratingCounts?: Array<IRatingCount>;
  reviews: IProductReview[];
  pagination?: {
    total: number;
    page: number;
    pageSize: number;
  };
}
export interface IReviewDataPayload {
  comment?: string;
  images?: string[];
  videos?: string[];
}

export interface ICreateProductReviewPayload {
  productUrl?: string;
  rating: number;
  sellerId: number;
  review?: IReviewDataPayload;
}

export interface ICreateProductReviewResponseData {
  id: number;
}

export interface ICreateProductReviewResponse {
  code: number;
  traceId: string;
  message: string;
  data: ICreateProductReviewResponseData;
}

export interface IRatingData {
  data?: IGetProductReviewResponse;
  reviews: IProductReview[];
  ratingCounts?: IRatingCount[];
  averageRating?: number;
  totalReviews?: number;
  filterParams?: Pick<
    IGetProductReviewsParams,
    'rating' | 'hasImage' | 'hasVideo'
  >;
  setFilterParams: (
    value?: Pick<IGetProductReviewsParams, 'rating' | 'hasImage' | 'hasVideo'>,
  ) => void;
  loadMore: () => void;
  hasMore: boolean;
  noFilter: boolean;
  numberOfReviewsRemaining: number;
  setPage: (value: number) => void;
  isValidating: boolean;
  refreshReviewList: () => void;
}

export interface IGetCustomerProfileRequest {
  platformId: number;
  clientCode?: string;
  partnerCode?: string;
  partnerToken?: string;

  /** @deprecated */
  platformCode?: string;
}

export interface IGetCustomerProfileResponse {
  code: number;
  message: string;
  result: {
    profile: Profile;
  };
}

export interface ICreateStudentInfoPayload {
  platformId: number;
  name?: string;
  schoolEmail?: string;
  schoolGrade?: ESchoolGrade;
  studentId?: string;
  expiredAt?: number;
  schoolName?: string;
  schoolYear?: string;
  studentCardImages?: string[];
  additionalDocumentsImages?: string[];
}

export interface ICreateStudentInfoResponse {
  code: number;
  message: string;
  data: {
    profileId?: string;
  };
}

export interface ISendOTPRequest {
  email: string;
}

export interface IVerifyOTPRequest {
  email: string;
  otp: string;
}

export interface ISendOrVerifyOTPResponse {
  code: number;
  traceId: string;
  message: string;
  data: {
    email: string;
  };
}

export enum EComboBundleSourceType {
  COMBO_PROMOTIONS = 'COMBO_PROMOTIONS',
  BUNDLE_RULES = 'BUNDLE_RULES',
}

export type GetProductBundleOrComboParams = {
  platformId: number;
  /** @description List skus, comma separated */
  skus: string;
  sourceType: EComboBundleSourceType;
  terminalId: number;
};

export type GetProductBundleOrComboResponse = {
  code: number;
  traceId: string;
  message: string;
  data: {
    products: IComboProduct[];
  };
};

export type PunchoutCheckoutPayload = {
  cartItems: PunchoutCartItem[];
};

type PunchoutCartItem = {
  sku: string;
  name: string;
  quantity: number;
  unitPrice: number;
  uomCode?: string;
  uomName?: string;
};

export type PunchoutCheckoutResponse = {
  code: number;
  traceId: string;
  message: string;
  data: {
    redirectUrl: string;
  };
};
